import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router, NavigationExtras } from '@angular/router';
import { Observable } from 'rxjs';
import { SurveyService } from '../services/survey.service';
import { PopCalendlyComponent } from '../components/modals/pop-calendly/pop-calendly.component';
import { ModalController, PopoverController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class ExitPollGuard implements CanActivate {

  constructor(
    private router: Router,
    private surveyService: SurveyService,
    private modalController:ModalController
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return new Promise(async (resolve) => {
        await this.surveyService.getExitPoll().subscribe(response => {
            let hasSurvey = response['status'] == 200 && typeof response['survey'] != 'undefined' ? true : false;
            let surveyPendingSettlementDate = response['survey_pending_settlement_date']
            if(hasSurvey){
                let survey = response['survey'];
                let navigationExtras: NavigationExtras = {
                state: {
                    survey
                }
                };
                this.router.navigate(['survey/survey-available'],navigationExtras);
            }else{
              if(surveyPendingSettlementDate){
                  let canShowCalendly = surveyPendingSettlementDate.has_settlement_date;
                  let urlSettlementDate = surveyPendingSettlementDate.url_settlement_date;
                  if (canShowCalendly) {
                  this.modalCalendy(surveyPendingSettlementDate,urlSettlementDate,)
                 resolve(false);
                }

             }
            }
            resolve(!hasSurvey);
        },(error) => {
          resolve(true);
       });
    });
  }
   async modalCalendy(surveyPendingSettlementDate,urlSettlementDate){

      const popover = await this.modalController.create({
        component: PopCalendlyComponent,
        cssClass: 'tooltip-input-custom',
        mode: 'ios',
        swipeToClose: false,
        backdropDismiss: false,
        componentProps: { hasPostponeSettlementDate:surveyPendingSettlementDate.has_postpone_settlement_date,days:surveyPendingSettlementDate.days_rest}
      });
    
      popover.onDidDismiss().then((data) => {
          this.router.navigate(['/survey/calendly'], {
                  state: {
                  survey: surveyPendingSettlementDate,
                  url_settlement_date: urlSettlementDate,
                 }
                 }); 
      })
      return await popover.present();
    }
}
